import { removePropertyEmpty } from '@/utils/index'
import { Service } from '../config'

class ProductService extends Service {
  path = 'produto'

  async get(payload: any) {
    const httpResponse = this.httpClient.get(this.path, {
      params: removePropertyEmpty(payload)
    })
    return httpResponse
  }

  async download(payload: any) {
    const httpResponse = await this.httpClient.get(`${this.path}/excel`, {
      params: removePropertyEmpty(payload)
    })
    return httpResponse
  }

  async post(params: any) {
    const httpResponse = await this.httpClient.post(this.path, params)
    return httpResponse
  }

  async delete(params: any) {
    const httpResponse = await this.httpClient.delete(
      this.path + `?produtoId=${params}`
    )
    return httpResponse
  }

  async put(id: any, params: any) {
    const httpResponse = await this.httpClient.put(
      this.path + `?produtoId=${id}`,
      params
    )
    return httpResponse
  }
}

export const productService = new ProductService()
